import { overviewStats, tickerItems } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] lg:min-h-[720px] flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20live%20streaming%20stage%20with%20dramatic%20warm%20coral%20and%20golden%20amber%20neon%20light%20beams%20on%20a%20deep%20dark%20background%2C%20glowing%20bokeh%20particles%20and%20soft%20haze%2C%20stylized%20cinematic%20editorial%20visual%2C%20wide%20composition%2C%20no%20text&width=1920&height=1080&seq=km-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16">
        <div className="max-w-4xl km-fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-sm text-accent-200 text-xs md:text-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            快猫内容生态 · 单页速览
          </div>
          <h1 className="font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight tracking-tight">
            快猫直播内容全景
            <br />
            主播 · 短视频 · 深夜看点一次看清
          </h1>
          <p className="mt-6 text-background-200 text-sm md:text-lg leading-relaxed max-w-2xl">
            本站把快猫平台的直播分区、热门主播风格、短视频题材、福利内容观看方式，以及 VIP 权限与深夜档差异，
            整理成一页可检索的导航。不用在推荐流里盲刷，从下面的分区或标签直接找到你想看的内容类型。
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#live"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 cursor-pointer transition-colors"
            >
              <i className="ri-live-line"></i>
              看直播分区
            </a>
            <a
              href="#video"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-white/10 backdrop-blur-sm border border-white/25 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-white/20 cursor-pointer transition-colors"
            >
              <i className="ri-play-circle-line"></i>
              逛短视频题材
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 max-w-4xl">
          {overviewStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-white/10 backdrop-blur-sm border border-white/15 p-3 md:p-4"
            >
              <div className="flex items-center gap-2 text-accent-300 mb-1.5">
                <span className="w-7 h-7 flex items-center justify-center">
                  <i className={`${s.icon} text-lg`}></i>
                </span>
                <span className="text-[11px] md:text-xs text-background-200">{s.label}</span>
              </div>
              <div className="font-heading font-bold text-background-50 text-lg md:text-2xl">{s.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-white/10 bg-black/30 backdrop-blur-sm overflow-hidden">
        <div className="flex items-center gap-3 py-3 px-4 md:px-8">
          <span className="shrink-0 inline-flex items-center gap-1.5 text-[11px] md:text-xs text-accent-300 font-medium">
            <i className="ri-radar-line"></i>
            更新
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex gap-8 km-ticker whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={i} className="text-xs md:text-sm text-background-200 flex items-center gap-2">
                  <i className="ri-flashlight-line text-primary-400"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}